export function getPrinterConfig() {
  try {
    const config = JSON.parse(localStorage.getItem("printer_config") || "null");
    if (config?.method === "qz") {
      const migrated = { method: "rawbt", width: config.width || 58 };
      localStorage.setItem("printer_config", JSON.stringify(migrated));
      return migrated;
    }
    return config;
  } catch {
    return null;
  }
}
export function savePrinterConfig(cfg) {
  const saved = {
    method: cfg?.method === "browser" ? "browser" : "rawbt",
    width: cfg?.width === 80 ? 80 : 58,
  };
  localStorage.setItem("printer_config", JSON.stringify(saved));
}

export function getReceiptConfig() {
  try {
    const config = JSON.parse(localStorage.getItem("receipt_config") || "null");
    if (config?.print_method === "qz") {
      const migrated = { ...config, print_method: "rawbt" };
      localStorage.setItem("receipt_config", JSON.stringify(migrated));
      return migrated;
    }
    return config;
  } catch {
    return null;
  }
}
export function saveReceiptConfig(cfg) {
  const saved = { ...(cfg || {}) };
  if (saved.print_method === "qz") saved.print_method = "rawbt";
  localStorage.setItem("receipt_config", JSON.stringify(saved));
}

const money = (n) => "Rp " + (Number(n) || 0).toLocaleString("id-ID");
const escapeHtml = (value) => String(value ?? "").replace(/[&<>"']/g, (character) => ({
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#039;",
}[character]));

export function receiptHtml(s, width = 58) {
  const cfg = getReceiptConfig() || {};
  const name = escapeHtml(cfg.store_name || "VENTEDAILY");
  const addr = (cfg.address || "").split("\n").filter(Boolean).map((line) => `<div class="c" style="font-size:10px">${escapeHtml(line)}</div>`).join("");
  const phone = cfg.phone ? `<div class="c" style="font-size:10px">${escapeHtml(cfg.phone)}</div>` : "";
  const footer = (cfg.footer || "Terima kasih :)").split("\n").filter((line) => line !== undefined).map((line) => `<div class="c" style="font-size:10px">${escapeHtml(line)}</div>`).join("");
  const totalPcs = (s.items || []).reduce((a, it) => a + (Number(it.qty) || 0), 0);
  const items = (s.items || []).map((it) =>
    `<tr><td colspan="2">${escapeHtml(it.product_name)} ${escapeHtml(it.color)}/${escapeHtml(it.size)}</td></tr>
     <tr><td>${it.qty} x ${money(it.price)}</td><td class="r">${money(it.total)}</td></tr>`).join("");
  return `<html><head><meta charset="utf-8"><style>
    @page{size:${width}mm auto;margin:0}
    *{margin:0;padding:0;box-sizing:border-box}
    html,body{width:${width}mm}
    body{font-family:'Courier New',monospace;font-size:11px;color:#000;padding:2mm}
    .c{text-align:center}.r{text-align:right}.b{font-weight:bold}
    hr{border:none;border-top:1px dashed #000;margin:3px 0}
    table{width:100%;border-collapse:collapse;table-layout:fixed}td{font-size:11px;vertical-align:top;overflow-wrap:anywhere}
    h3{font-size:14px;margin:0}
    @media print{html,body{width:${width}mm}}
  </style></head><body>
    <div class="c b"><h3>${name}</h3></div>
    ${addr}${phone}
    <hr>
    <div>No  : ${escapeHtml(s.number || "-")}</div>
    <div>Tgl : ${s.created_at ? new Date(s.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short", timeZone: "Asia/Jakarta" }) + " WIB" : "-"}</div>
    <div>Cust: ${escapeHtml(s.customer_name || "-")}</div>
    ${s.keep_number ? `<div>Keep: ${escapeHtml(s.keep_number)}</div>` : ""}
    ${s.order_id ? `<div>Order ID: ${escapeHtml(s.order_id)}</div>` : ""}
    <hr>
    <table>${items}</table>
    <hr>
    <table>
      <tr><td>Subtotal</td><td class="r">${money(s.sub_total)}</td></tr>
      ${s.discount ? `<tr><td>Diskon</td><td class="r">-${money(s.discount)}</td></tr>` : ""}
      ${Number(s.shipping_cost || 0) > 0 ? `<tr><td>Ongkos Kirim</td><td class="r">${money(s.shipping_cost)}</td></tr>` : ""}
      ${cfg.show_tax ? `<tr><td>Pajak</td><td class="r">${money(s.tax)}</td></tr>` : ""}
      <tr class="b"><td>TOTAL</td><td class="r">${money(s.grand_total)}</td></tr>
      <tr><td>Total pcs</td><td class="r">${totalPcs}</td></tr>
      <tr><td>${s.payment_method || "Cash"}</td><td class="r">${money(s.cash_received)}</td></tr>
      <tr><td>Kembali</td><td class="r">${money(s.change)}</td></tr>
    </table>
    <hr>
    <div>Kasir: ${escapeHtml(s.created_by || s.cashier_name || "-")}</div>
    <hr>
    ${footer}
    <div style="height:8mm"></div>
  </body></html>`;
}

function padLine(l, r, cols) {
  const space = cols - l.length - r.length;
  return l + (space > 0 ? " ".repeat(space) : " ") + r;
}

function center(t, cols) {
  const space = Math.max(0, Math.floor((cols - t.length) / 2));
  return " ".repeat(space) + t;
}

function wrapText(value, cols) {
  const text = String(value || "").trim();
  if (!text) return [""];
  const lines = [];
  let remaining = text;
  while (remaining.length > cols) {
    const breakAt = remaining.lastIndexOf(" ", cols);
    const end = breakAt > 0 ? breakAt : cols;
    lines.push(remaining.slice(0, end));
    remaining = remaining.slice(end).trimStart();
  }
  lines.push(remaining);
  return lines;
}

function normalizeRawBtText(text) {
  const normalized = String(text).replace(/\r?\n/g, "\r\n").replace(/(?:\r\n)+$/, "");
  return `${normalized}\r\n\r\n\r\n\r\n\r\n\r\n`;
}

function base64Utf8(value) {
  const bytes = new TextEncoder().encode(value);
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
}

export function receiptText(s, cols = 32) {
  const cfg = getReceiptConfig() || {};
  const m = (n) => (Number(n) || 0).toLocaleString("id-ID");
  const div = "-".repeat(cols);
  const o = [center((cfg.store_name || "VENTEDAILY"), cols)];
  (cfg.address || "").split("\n").filter(Boolean).forEach((l) => o.push(center(l.slice(0, cols), cols)));
  if (cfg.phone) o.push(center(cfg.phone, cols));
  o.push(div,
    "No  : " + (s.number || "-"), "Tgl : " + (s.created_at ? new Date(s.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short", timeZone: "Asia/Jakarta" }) + " WIB" : "-"),
    "Cust: " + (s.customer_name || "-"));
  if (s.keep_number) o.push("Keep: " + s.keep_number);
  if (s.order_id) o.push("Order ID: " + s.order_id);
  o.push(div);
  const totalPcs = (s.items || []).reduce((a, it) => a + (Number(it.qty) || 0), 0);
  (s.items || []).forEach((it) => {
    const itemName = `${it.product_name || ""} ${it.color || ""}/${it.size || ""}`;
    o.push(...wrapText(itemName, cols));
    o.push(padLine(`  ${it.qty} x ${m(it.price)}`, m(it.total), cols));
  });
  o.push(div, padLine("Subtotal", m(s.sub_total), cols));
  if (s.discount) o.push(padLine("Diskon", "-" + m(s.discount), cols));
  if (Number(s.shipping_cost || 0) > 0) {
    o.push(padLine("Ongkos Kirim", m(s.shipping_cost), cols));
  }
  if (cfg.show_tax) o.push(padLine("Pajak", m(s.tax), cols));
  o.push(padLine("TOTAL", m(s.grand_total), cols), padLine("Total pcs", String(totalPcs), cols),
    padLine((s.payment_method || "Cash"), m(s.cash_received), cols),
    padLine("Kembali", m(s.change), cols), div, "Kasir: " + (s.created_by || s.cashier_name || "-"), div);
  (cfg.footer || "Terima kasih :)").split("\n").forEach((l) => o.push(center(l.slice(0, cols), cols)));
  return o.join("\r\n");
}

export const isAndroidDevice = () => /Android/i.test(navigator.userAgent);

// Print RawBT hanya pada Android. Desktop dan iOS memakai dialog browser.
function browserPrint(html) {
  return new Promise((resolve, reject) => {
    const iframe = document.createElement("iframe");
    let cleaned = false;
    let timeoutId = null;
    const cleanup = () => {
      if (cleaned) return;
      cleaned = true;
      if (timeoutId) window.clearTimeout(timeoutId);
      iframe.remove();
    };
    iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
    iframe.onload = async () => {
      try {
        const frameDocument = iframe.contentDocument;
        if (frameDocument?.fonts?.ready) await frameDocument.fonts.ready;
        iframe.contentWindow.addEventListener("afterprint", () => {
          cleanup();
          resolve("browser");
        }, { once: true });
        timeoutId = window.setTimeout(() => {
          cleanup();
          resolve("browser");
        }, 60000);
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch (error) {
        cleanup();
        reject(error);
      }
    };
    iframe.srcdoc = html;
    document.body.appendChild(iframe);
  });
}

export async function printReceipt(sale) {
  const cfg = getPrinterConfig() || {};
  const rc = getReceiptConfig() || {};
  const method = cfg.method || rc.print_method || "browser";
  const width = cfg.width || rc.paper_width || 58;
  if (method === "rawbt" && isAndroidDevice()) {
    const cols = width >= 80 ? 48 : 32;
    const text = normalizeRawBtText(receiptText(sale, cols));
    const payload = `rawbt:data:text/plain;base64,${base64Utf8(text)}`;
    window.location.href = payload;
    return "rawbt";
  }
  return browserPrint(receiptHtml(sale, width));
}
